'use strict';

/**
 *
 * @name: TranslationsLoaderConfig
 *
 */

function TranslationsLoaderConfig($translateProvider) {

  'ngInject';

  $translateProvider.useLoader('translationsLoader');
}

export default TranslationsLoaderConfig;



// WEBPACK FOOTER //
// ./app/components/nn-translations/nn-translations-loader.config.js